_ = require 'underscore'
assert = require 'app/scripts/lib/assert'
f = require 'effing'

module.exports = class FeatureSet
  constructor: (products, options = {}) ->
    # a map from product ids to the name of the product
    @products = {}
    # a map from product ids to the price of the product
    @prices = {}
    # a map from product ids to the billing interval ("monthly" or "yearly")
    @intervals = {}
    # a map from product short names to their ids
    @productShortNames = {}
    # a list of which products are billed at the start of the pay period
    @prebilledProducts = {}
    # a map between productt numbers and an array containing what features that product adds
    @productFeatures = {}
    # a list of per-user products
    @perUserProducts = {}
    @perActiveUserProducts = {}
    # a map with products that pay with a purchase order
    @purchaseOrderProducts = {}
    # features everyone should have enabled
    @globalFeatures = options.globalFeatures ? []
    #products that should ask you to upgrade to the latest
    @upgradeProducts = []
    @yearlyEquivalents = {}

    assert(options.currentProducts)
    { @currentProducts } = options

    _.extend @, options.extras

    for product, spec of products
      productNumber = parseInt(product, 10)
      spec = _.extend
        interval: 'monthly'
        hidden: false
        prebill: true
        perUser: false
        features: []
        upgrade: false
      , spec

      @products[productNumber] = spec.name

      if !spec.hidden
        @productShortNames[spec.shortName] = productNumber

      @prebilledProducts[productNumber] = spec.prebill
      @perUserProducts[productNumber] = spec.perUser
      @perActiveUserProducts[productNumber] = spec.perActiveUser
      @productFeatures[productNumber] = spec.features
      @prices[productNumber] = spec.price
      @intervals[productNumber] = spec.interval
      @upgradeProducts[productNumber] = spec.upgrade
      @yearlyEquivalents[productNumber] = spec.yearlyEquivalent
      @purchaseOrderProducts[productNumber] = spec.purchaseOrder

    return

  _convertToId: (product) ->
    if _.isString(product)
      if /^\d+$/.test(product)
        parseInt(product, 10)
      else
        @productShortNames[product]
    else
      product

  getProductNumber: (product) ->
    @_convertToId(product)

  getPrice: (product) ->
    @prices[@_convertToId(product)]

  getInterval: (product) ->
    @intervals[@_convertToId(product)]

  isMonthly: (product) ->
    @getInterval(product) == 'monthly'

  isYearly: (product) ->
    @getInterval(product) == 'yearly'

  isPerActiveUser: (product) ->
    @perActiveUserProducts[@_convertToId(product)]

  isPerUser: (product) ->
    @perUserProducts[@_convertToId(product)]

  isPrebilled: (product) ->
    @prebilledProducts[@_convertToId(product)]

  isUpgrade: (product) ->
    @upgradeProducts[@_convertToId(product)]

  usesPurchaseOrder: (product) ->
    @purchaseOrderProducts[@_convertToId(product)]

  getYearlyEquivalent: (product) ->
    @yearlyEquivalents[@_convertToId(product)]

  getYearlyDiscountPercent: (productYearly, productMonthly) ->
    priceYearly = @getPrice(productYearly)
    priceMonthly = 12 * @getPrice(productMonthly)

    Math.round(100 * (priceMonthly - priceYearly) / priceMonthly)

  features: (productNumbers = []) ->
    _.chain(productNumbers)
    .map f.lookup(@productFeatures)
    .tap (featureLists) ->
      assert _.all(featureLists, f.id), "FeatureSet::features called on an unrecognized product: #{productNumbers}"
    .flatten()
    .unique()
    .value()

  hasProduct: (productNumbers = []) ->
    _.any productNumbers, (productNumber) => productNumber of @products

  # checks to see if a given feature is enabled by any of the products listed
  isFeatureEnabled: (feature, productNumbers) ->
    feature in @globalFeatures || feature in @features(productNumbers)
